@if (tooltipDisabled() || (!shouldEllipsis() && showTooltipOnlyEllipsized())) {
  <span (fwResized)="onResize()">
    <ng-container [ngTemplateOutlet]="contentTmpl"></ng-container>
  </span>
} @else {
  <fw-tooltip [title]="effectiveTooltip()" [position]="tooltipPosition()" [maxWidth]="tooltipMaxWidth()" (fwResized)="onResize()">
    <ng-container [ngTemplateOutlet]="contentTmpl"></ng-container>
  </fw-tooltip>
}

<ng-template #contentTmpl>
  @if (displayText().main.length > 0 || !shouldEllipsis()) {
    <span #ellipsisTmpl class="ellipsis">{{ shouldEllipsis() ? displayText().main : text() }}</span>
  }
  @if (shouldEllipsis()) {
    <span #endcapTmpl class="endcap">{{ displayText().end }}</span>
  }
</ng-template>
